export const login = 'appgo.login';

export const token_timeout = 'appgo.token.timeout';

export const pwa_never_display = 'appgo.pwa.neverdisplay';